import type {
    CrmListRoutingParams,
    StaticListRoutingParams,
} from "app/pages/sales-intelligence/sub-modules/opportunities/types/routing";
import type { StateParamsDeclaration } from "app/pages/sales-intelligence/types/routing";

export const staticListRoutingParams: StateParamsDeclaration<StaticListRoutingParams> = {
    isRecent: { dynamic: true },
    id: { dynamic: true },
};

export const crmListRoutingParams: StateParamsDeclaration<CrmListRoutingParams> = {
    crm: { dynamic: true },
    objectType: { dynamic: true },
};
